import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { LANG } from 'app/constants';
import { focusRing } from 'ui/a11y';

const Group = styled.div`
  display: flex;
  gap: 2px;
  padding: 2px;
  border: 1px solid ${p => p.theme.colors.neutral};
  border-radius: 6px; /* tuned to this pill, not a token radius */
`;

const LangButton = styled.button<{ $selected: boolean }>`
  height: 28px; /* below the 44px touch-target floor — the user approved this pair specifically */
  padding: 0 10px;
  border: 0;
  border-radius: 4px;
  font-family: ${p => p.theme.font.family};
  font-size: 14px;
  font-weight: ${p => (p.$selected ? p.theme.font.weight.bold : p.theme.font.weight.regular)};
  background: ${p => (p.$selected ? p.theme.colors.brown : 'transparent')};
  color: ${p => (p.$selected ? p.theme.colors.pale : p.theme.colors.brown)};
  cursor: pointer;

  ${focusRing}
`;

export interface LanguageSwitchProps {
  language: string;
  onChange: (lng: string) => void;
  className?: string;
}

/**
 * The two-button ET/EN pill (`V2-Account-*`/`V2-390` artboards). Used both in the bar on public
 * pages and inside the account menu's Keel row — same component either way.
 */
export function LanguageSwitch({ language, onChange, className }: LanguageSwitchProps) {
  const { t } = useTranslation();

  return (
    <Group role="group" aria-label={t('header.language')} className={className}>
      <LangButton
        type="button"
        lang="et"
        $selected={language === LANG.ET}
        aria-pressed={language === LANG.ET}
        onClick={() => onChange(LANG.ET)}
      >
        Eesti
      </LangButton>
      <LangButton
        type="button"
        lang="en"
        $selected={language === LANG.EN}
        aria-pressed={language === LANG.EN}
        onClick={() => onChange(LANG.EN)}
      >
        English
      </LangButton>
    </Group>
  );
}

export default LanguageSwitch;
